//function to check whether parameter is a valid non empty string, i.e. neither undefined nor empty
export const checkEmpty = (value: any) => {
  return value !== "" && value !== undefined;
};
